/**
 * Coerce Firestore / JSON values to finite numbers for display math.
 * Guards `.toFixed()` crashes when a field arrives as a string.
 */
export function coerceFiniteNumber(value: unknown, fallback = NaN): number {
  const n = typeof value === 'number'
    ? value
    : typeof value === 'string' && value.trim()
      ? Number(value)
      : NaN;
  return Number.isFinite(n) ? n : fallback;
}

/** Format a possibly non-numeric value with `.toFixed`, or return fallback. */
export function formatFixed(value: unknown, digits: number, fallback = '–'): string {
  const n = coerceFiniteNumber(value);
  return Number.isFinite(n) ? n.toFixed(digits) : fallback;
}

/** Coerce store / Firestore progress to a finite 0–100 integer. */
export function normalizeProgressPercent(value: unknown): number {
  const n = coerceFiniteNumber(value, 0);
  return Math.min(100, Math.max(0, Math.round(n)));
}
